import usePersistentStore from '@gui/store/persistent/persistentStore';
import { VisualizationElements } from 'Graphics/VisualizationElements';
import { getGrid, LoadingStatus, useLoadingStore } from 'store/LoadingStore';
import { getViewer } from 'store/viewerStore';
import type { VisualizationElementId } from '@rendering/types/VisualizationElements';

class RendererController {
    constructor() {
        usePersistentStore.subscribe(
            (state) => state.layers.layerStates[state.layers.activeLayerID]?.element?.SEL_VIS_ELEMENT,
            (selElement) => {
                this.refreshVisElement(selElement);
            }
        );

        usePersistentStore.subscribe(
            (state) => state.layers.activeLayerID,

            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                getViewer().refreshFrames();
            }
        );

        usePersistentStore.subscribe(
            (state) => state.layers.layerStates[state.layers.activeLayerID]?.element?.normalized,
            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                getViewer().refreshFrames();
            }
        );

        usePersistentStore.subscribe(
            (state) => state.layers.layerStates[state.layers.activeLayerID]?.element?.ELEMENT_SPIN,
            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                getViewer().refreshFrames();
            }
        );

        usePersistentStore.subscribe(
            (state) => ({
                showGrid: state.global.context.showGrid,
                showZeroValues: state.layers.layerStates[state.layers.activeLayerID]?.element?.SHOW_ZERO_VALUE_POINTS,
            }),
            ({ showGrid, showZeroValues }) => {
                const renderer = getViewer().getInstanceRenderer();
                renderer?.syncContextVisibility(showGrid, showZeroValues);
            }
        );

        usePersistentStore.subscribe(
            (state) => state.global.overlays.fpsIndicatorVisible,
            (fpsIndicatorVisible) => {
                getViewer().setStatsVisibility(fpsIndicatorVisible);
            }
        );

        usePersistentStore.subscribe(
            (state) => state.layers.layerStates[state.layers.activeLayerID]?.element?.SENSOR_COLOR_MODE,
            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                getViewer().refreshFrames();
            }
        );

        // Handles No Strokes for Land Analysis:
        usePersistentStore.subscribe(
            (state) => state.layers.layerStates[state.layers.activeLayerID]?.element?.NO_STROKES,
            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                getViewer().refreshFrames();
            }
        );

        // This is necessary to update shadows when updateing frame:
        usePersistentStore.subscribe(
            (state) => ({
                activeLayerID: state.layers.activeLayerID,
                frameSelected: state.layers.layerStates[state.layers.activeLayerID]?.segments?.frameSelected,
                isAggregate: state.layers.layerStates[state.layers.activeLayerID]?.segments?.isAggregate,
                framesList: state.layers.layerStates[state.layers.activeLayerID]?.segments?.framesList,
            }),
            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                const activeLayer = getGrid().getActiveLayer();
                activeLayer.getActiveFrame().updateShadows();
                getViewer().requestRender('ui');
            }
        );
    }

    refreshVisElement(selectedElement: VisualizationElementId) {
        if (selectedElement === undefined) return;
        const element = VisualizationElements.getVisualizationElement(selectedElement);
        getViewer().getInstanceRenderer()?.updateMeshGeometry(element);
    }
}
export default RendererController;
